var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "14900a4e40e61d7f4c17a6b21a0ba07e71c1f39f"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-elpaso@rodi"] = {
  id: "14900a4e40e61d7f4c17a6b21a0ba07e71c1f39f"
};